"use client";

import { PopoverTrigger as HeroPopoverTrigger } from "@heroui/react";
import { cn } from "../../lib/utils";

export const PopoverTrigger = ({
  className,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroPopoverTrigger>) => {
  return <HeroPopoverTrigger className={cn(className)} {...props} />;
};
